import { zExt } from "$root/third-party-integrations/zod";
import { type TypeOf, z } from "zod";

export const zAgGridColumnState = z.object({
	colId: z.string(),
	hide: z.boolean().optional().nullable(),
	width: z.number().optional(),
	flex: z.number().optional().nullable(),
	sort: z.enum(["asc", "desc"]).optional().nullable(),
	sortIndex: z.number().optional().nullable(),
	pivot: z.boolean().optional().nullable(),
	pivotIndex: z.number().optional().nullable(),
	pinned: z.enum(["left", "right"]).or(z.boolean()).optional().nullable(),
	rowGroup: z.boolean().optional().nullable(),
	rowGroupIndex: z.number().optional().nullable(),
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const zAgGridColStateV1 = () => zExt.versioned(1, z.array(zAgGridColumnState));

export type AgGridColState = TypeOf<ReturnType<typeof zAgGridColStateV1>>;
